<template>
  <div class="w-full flex flex-col gap-4">
    <h4 class="text-h4">What is a CareerWise Connection?</h4>
    <p>
      A CareerWise Connection can be either a parent or an organisation
      committed to assisting the school and its students. We recognise that
      parents are often employed and possess valuable work experience that can
      guide students in making informed career decisions post graduation. By
      generously sharing your knowledge and career journey with students, you
      can serve as a source of inspiration and help them make more informed
      choices about their future careers.
    </p>
    <p>
      A CareerWise Connection offers various forms of support to the school
      community. This support includes activities such as delivering
      presentations to students about your profession, conducting mock
      interviews, providing work opportunities, and more. Additionally, support
      can extend to actions such as sponsorship, coaching a sports team,
      participating in the PTA board, and other contributions.
    </p>
    <p>
      The goal of CareerWise Connections is to establish a comprehensive
      database of contacts spanning communities and regions, which schools can
      access to identify suitable partners. This initiative aligns with the
      government's National Education Learning Priorities and facilitates the
      connection between classroom learning and real-world applications.
    </p>
    <p>
      Furthermore, our platform enables schools to track and document
      interactions between parents and organisations, allowing them to report on
      these activities throughout the year.
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalInfo',
})
</script>
